import { useCampaignCapabilitiesStore } from '@discovr/features';
import type { AssignedProduct } from '@discovr/types';
import { usePublicView } from '../publicView';

export interface ProductRow {
  id: string;
  status?: string;
  assigned_products?: AssignedProduct[];
  previous_assigned_products?: AssignedProduct[];
  products_locked_at?: string | null;
}

export const isProductsLocked = (row: Pick<ProductRow, 'products_locked_at'>): boolean => !!row.products_locked_at;

/** A confirmed creator whose products a rollback set aside and nothing has replaced them yet. */
export function shouldOfferPreviousProducts(row: ProductRow): boolean {
  return (
    row.status === 'accepted_by_creator' &&
    (row.previous_assigned_products ?? []).length > 0 &&
    (row.assigned_products ?? []).length === 0
  );
}

/** Brand and admin writers only; creators and public share views never resolve set-aside products. */
export function useCanResolvePreviousProducts(): boolean {
  const { isPublicView } = usePublicView();
  const { lane, permissions } = useCampaignCapabilitiesStore();
  return (lane === 'admin' || lane === 'brand') && !isPublicView && !!permissions?.canResolvePreviousProducts;
}
